/**
 * Run Q / Q-4 — which optional modules a clinic has switched on.
 *
 * Today that is Front Desk only. The flag lives at
 * `clinics.settings.frontDesk.enabled`, seeded by migration 0057 from what the
 * audit log says the desk actually did in the last 30 days (see
 * backend/src/db/migrate.ts seedFrontDeskModuleFlag). The sync and the
 * reconciliation keep running whatever this says, so switching the module back
 * on shows current data, not a cold start.
 */
export interface ClinicModules {
  frontDesk: boolean;
}

/**
 * A clinic with no flag has never had the module seeded — a brand-new clinic,
 * i.e. one with no desk history. Off is the honest default: showing a module
 * with 51 dropout flags nobody reads is worse than not showing it.
 */
export const MODULES_DEFAULT: ClinicModules = { frontDesk: false };

export function readClinicModules(settings: unknown): ClinicModules {
  if (!settings || typeof settings !== 'object') return MODULES_DEFAULT;
  const fd = (settings as { frontDesk?: unknown }).frontDesk;
  if (!fd || typeof fd !== 'object' || Array.isArray(fd)) return MODULES_DEFAULT;
  const enabled = (fd as { enabled?: unknown }).enabled;
  return { frontDesk: enabled === true };
}
